import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-school-logo',
  templateUrl: './school-logo.component.html',
  styleUrls: ['./school-logo.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: []
})
export class SchoolLogoComponent {
  @Input() logo: string;
}
